module.exports = '<svg width="26" height="32" viewBox="0 0 26 32"><path d="M9.602 12.806V1.674C9.602.79 10.319 0 11.203 0h3.202c.884 0 1.601.791 1.601 1.674v11.132h7.492c1.985 0 2.689 1.412 1.601 3.013L14.79 30.825c-1.089 1.601-2.881 1.543-3.97-.026L.511 15.812c-1.089-1.562-.384-3.006 1.601-3.006h7.492z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/down-3.js
// module id = 1106
// module chunks = 14